export default function getResource(label, vars = []) {
    const resources = {
        thisCardHasExpired: 'Cette carte est expirée. Veuillez effectuer une mise à jour des renseignements de votre carte.',
        defaultCreditCard: 'Carte par défaut',
        makeDefaultCreditCard: 'Définir comme carte par défaut',
        edit: 'Modifier',
        addCreditCard: 'Ajoutez une carte de crédit ou de débit',
        cardDescText: `${vars[0]} terminant en ${vars[1]}`,
        cardExpirationText: `Expiration ${vars[0]} ${vars[1]}`,
        debitCardDisclaimer: 'Cartes de débit Visa et Mastercard seulement',
        gotIt: 'Compris',
        accountUpdateModal: 'Account Update',
        defaultCardErrorModal: 'Unable to set this card as default at the moment. Please try again later.',
        deleteCardErrorModal: 'Unable to delete this card at the moment. Please try again later.',
        done: 'Done',
        ok: 'Okay'
    };
    return resources[label];
}
